<template>
  <p class="font-bold leading-tight text-5xl mt-0 mb-2 text-blue-800">Badanie interfejsów przetwarzania danych w
    Javie</p>
  <HelloWorld/>
  <p class="font-medium leading-tight mt-60 text-gray-600">Ankiety przygotowane przez Bartosza Krych, studenta
    Politechniki Wrocławskiej</p>
  <a href="https://www.freepik.com/vectors/blue-polygon"><p style="font-size: 10px">Background created by Harryarts</p>
  </a>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  padding-left: 35px;
  padding-right: 35px;
}

#bg {
  position: relative;
  /* The image used */
  background-image: url("static/img.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: repeat-y;
  background-size: cover;
}
</style>
